import { INTERVENTION_TYPE } from '@/types/jobs'
import type { InterventionType, JobPaymentSummary } from '@/types/jobs'

type DynamicStopPathSource = {
  intervention_type?: InterventionType | null
  amount_to_collect?: number | null
  quoteTotal?: number | null
  payments?: Pick<JobPaymentSummary, 'amount' | 'status'>[] | null
}

export type DynamicStopPath =
  | { path: 'collect'; amount: number }
  | { path: 'report'; amount: 0 }

function positiveMoney(value: number | null | undefined): number {
  return typeof value === 'number' && Number.isFinite(value)
    ? Math.max(value, 0)
    : 0
}

export function getDynamicStopPath(
  job: DynamicStopPathSource
): DynamicStopPath {
  const paidAmount = (job.payments ?? []).reduce(
    (total, payment) =>
      payment.status === 'paid' ? total + positiveMoney(payment.amount) : total,
    0
  )
  const targetAmount =
    job.intervention_type === INTERVENTION_TYPE.visit_quote
      ? positiveMoney(job.quoteTotal)
      : positiveMoney(job.amount_to_collect)
  const remainingAmount = Math.max(0, targetAmount - paidAmount)

  return remainingAmount > 0
    ? { path: 'collect', amount: remainingAmount }
    : { path: 'report', amount: 0 }
}
